var SetCameraTarget = function (camera) {
    this.waitEventManager.setCameraTarget(camera);
    return this;
}

export default SetCameraTarget;